// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {connect} from 'react-redux';

import routerActions from '../../actions/router';

import DatesPromptBanerImage from './DatesPromptBannerImage';

import './DatesPromptBanner.less';

type DispatchProps = {
    openDateRangePicker: () => typeof routerActions.pushModal
};
type Props = DispatchProps & {useXsImage?: boolean};

export function DatesPromptBanner({openDateRangePicker, useXsImage}: Props) {
    return (
        <div className="DatesPromptBanner jumbotron">
            <div className="DatesPromptBanner__Content">
                <h2 className="DatesPromptBanner__Header">
                    <FormattedMessage
                        id="datesPromptHeading"
                        description="datesPrompt Heading"
                        default="Heading for the dates prompt"
                    >
                        {(message) => message}
                    </FormattedMessage>
                </h2>
                <p className="DatesPromptBanner__text">
                    <FormattedMessage
                        id="datesPromptText"
                        description="datesPrompt text"
                        defaultMessage="Add some trip dates"
                    >
                        {(message) => message}
                    </FormattedMessage>
                </p>
                <ButtonPrimary
                    label={
                        <FormattedMessage
                            id="datesPromptAddButton"
                            description="datesPrompt btn"
                            defaultMessage="Add some dates"
                        >
                            {(message) => message}
                        </FormattedMessage>
                    }
                    onClick={openDateRangePicker}
                />
            </div>
            <div className="DatesPromptBanner__Image">
                <DatesPromptBanerImage useXsImage={useXsImage} />
            </div>
        </div>
    );
}

const mapDispatchToProps = {
    openDateRangePicker: () => routerActions.pushModal('DATES')
};

export default connect(
    null,
    mapDispatchToProps
)(DatesPromptBanner);
